import { render, staticRenderFns } from "./SportsFooter.vue?vue&type=template&id=2e0830d4"
import script from "./SportsFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportsFooter.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports